import React, { useEffect } from "react";

export default function LGSelectCellRenderer({
  value,
  labelTemplate = (v) => v.name,
}) {
  return <span>{labelTemplate(value)}</span>;
}
